import { render } from "./PedidoItemView.vue?vue&type=template&id=72bf0eb8&scoped=true"
import script from "./PedidoItemView.vue?vue&type=script&lang=js"
export * from "./PedidoItemView.vue?vue&type=script&lang=js"

import "./PedidoItemView.vue?vue&type=style&index=0&id=72bf0eb8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72bf0eb8"]])

export default __exports__